/**
 * @generated SignedSource<<408b83ab7ef90fcb5eeb07f1a6aea872>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { InlineFragment, ReaderInlineDataFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type ecommerceTracking_itemSearch$data = {
  readonly pageType: string | null;
  readonly searchTerm: string | null;
  readonly sponsored: {
    readonly metadata: ReadonlyArray<{
      readonly clickTrackerLink: string | null;
      readonly impressionTrackerLink: string | null;
      readonly itemId: string | null;
    } | null> | null;
  } | null;
  readonly " $fragmentType": "ecommerceTracking_itemSearch";
};
export type ecommerceTracking_itemSearch$key = {
  readonly " $data"?: ecommerceTracking_itemSearch$data;
  readonly " $fragmentSpreads": FragmentRefs<"ecommerceTracking_itemSearch">;
};

const node: ReaderInlineDataFragment = {
  "kind": "InlineDataFragment",
  "name": "ecommerceTracking_itemSearch"
};

(node as any).hash = "a208ce8994d057d2c518f054c80a75c2";

export default node;
